var _pattern, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBosciarose04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238.7 128.4",
    enableBackground: "new 0 0 238.7 128.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    x: -1107.9,
    y: -1244.4,
    width: 202.5,
    height: 123.4,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_5",
    viewBox: "0 -123.4 202.5 123.4",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -123.4,
    fill: "none",
    width: 202.5,
    height: 123.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M121.2-119.4l-17.1,17.1v16.8c2.9-6.5,6.8-12.9,11.7-19.3c6.9-9,13.7-15.1,16.3-17.4c0-0.4,0-0.8,0-1.2 h-10.7C122.4-122.3,122.3-120.5,121.2-119.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0BB68B",
    points: "104.1,-110.5 117,-123.4 105.3,-123.4 104.1,-122.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0BB68B",
    points: "98.3,-122.2 97.1,-123.4 85.4,-123.4 98.3,-110.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M98.3-85.6v-16.7l-17.1-17.1c-1.1-1.1-1.1-2.9-0.1-4H70.4c0,0.4,0,0.8,0,1.2 C74.6-118.5,89.8-104.6,98.3-85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M165.8-85.6v-16.7l-17.1-17.1c-1.1-1.1-1.1-2.9-0.1-4h-10.7c0,0.4,0,0.8,0,1.2 C142.1-118.5,157.3-104.6,165.8-85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M194.5-117.5c2.2-2.2,4-3.7,5-4.7c0-0.4,0-0.8,0-1.2h-4.9c0,0.7,0,1.3,0,2 C194.7-120.1,194.6-118.8,194.5-117.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0BB68B",
    points: "165.8,-122.2 164.6,-123.4 152.9,-123.4 165.8,-110.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M171.6-103.5C171.6-103.5,171.6-103.5,171.6-103.5v18c2.9-6.5,6.8-12.9,11.7-19.3c1.3-1.6,2.5-3.2,3.8-4.7 c1.1-3.9,1.8-7.9,1.8-12c0-0.7,0-1.3-0.1-2h-17.2c0,0,0,0,0,0V-103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M30.8-85.6v-16.7l-17.1-17.1c-1.1-1.1-1.1-2.9-0.1-4H2.9c0,0.4,0,0.8,0,1.2 C7.2-118.5,22.4-104.6,30.8-85.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0BB68B",
    points: "30.8,-122.2 29.6,-123.4 17.9,-123.4 30.8,-110.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M36.6-123.4C36.6-123.4,36.6-123.4,36.6-123.4l27.9,0c0,0.4,0,0.8,0,1.2c-2.6,2.2-9.4,8.4-16.3,17.4 c-4.9,6.4-8.8,12.9-11.7,19.3v-18c0,0,0,0,0,0V-123.4z M39.5-116.9c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4 c0-1.9-1.5-3.4-3.4-3.4C41.1-120.3,39.5-118.8,39.5-116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M64.6-23.9v-16.7L47.5-57.7c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l13,13v-11.7L47.7-77.4 c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l12.8,12.8v-13.8L53.8-93.4c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l6.7,6.7v-23.5 c-9,8.7-27.7,29.7-27.9,53.8C40.9-56.8,56.1-42.9,64.6-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M77.1-97.5c1.1-1.1,3-1.1,4.1,0c1.1,1.1,1.1,3,0,4.1L70.4-82.6v13.8l12.8-12.8c1.1-1.1,3-1.1,4.1,0 c1.1,1.1,1.1,3,0,4.1L70.4-60.5v11.7l13-13c1.1-1.1,3-1.1,4.1,0c1.1,1.1,1.1,3,0,4.1L70.4-40.6v16.8c2.9-6.5,6.8-12.9,11.7-19.3 c6.9-9,13.7-15.1,16.3-17.4c-0.2-24.1-18.9-45.1-27.9-53.8v23.5L77.1-97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M132.1-23.9v-16.7l-17.1-17.1c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l13,13v-11.7l-16.9-16.9 c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l12.8,12.8v-13.8l-10.8-10.8c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l6.7,6.7v-23.5 c-9,8.7-27.7,29.7-27.9,53.8C108.4-56.8,123.6-42.9,132.1-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M148.9-93.4c7.9,11.4,12.1,23,12.1,33.7c0,1.3-0.1,2.6-0.2,3.9c2.2-2.2,4-3.7,5-4.7 c-0.2-24.1-18.9-45.1-27.9-53.8v7.7C139.8-104.7,144.3-100,148.9-93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M137.9-98.1v14.3c0,0,0,0,0,0v22.1c0,0,0,0,0,0v19.9c0,0,0,0,0,0v18c2.9-6.5,6.8-12.9,11.7-19.3 c1.3-1.6,2.5-3.2,3.8-4.7c1.1-3.9,1.8-7.9,1.8-12C155.1-75.9,144.4-90.6,137.9-98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M30.8-60.5c-2.6,2.2-9.4,8.4-16.3,17.4C9.7-36.7,5.8-30.2,2.9-23.8v-18c0,0,0,0,0,0v-19.9c0,0,0,0,0,0 v-22.1c0,0,0,0,0,0v-30.5C11.9-105.5,30.6-84.5,30.8-60.5z M12.6-55.2c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4 c0,1.9,1.5,3.4,3.4,3.4C11.1-51.8,12.6-53.3,12.6-55.2z M12.6-65.3c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4 c0,1.9,1.5,3.4,3.4,3.4C11.1-61.8,12.6-63.4,12.6-65.3z M12.6-75.3c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4 C11.1-71.9,12.6-73.5,12.6-75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#974F9E",
    d: "M199.5-23.9v-16.7l-17.1-17.1c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l13,13v-11.7l-16.9-16.9 c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l12.8,12.8v-13.8l-10.8-10.8c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0l6.7,6.7v-23.5 c-9,8.7-27.7,29.7-27.9,53.8C175.9-56.8,191.1-42.9,199.5-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M81.4-15.7c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0L98.3-7v-13.8L87.5-31.7c-1.1-1.1-1.1-3,0-4.1 c1.1-1.1,3-1.1,4.1,0l6.7,6.7v-23.5C89.5-44,71.3-23.6,70.4,0h10.7c0,0,0-0.1,0.1-0.1c1.1-1.1,3-1.1,4.1,0L85.4,0h11.7L81.4-15.7z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M104.1-52.6v23.5l6.7-6.7c1.1-1.1,3-1.1,4.1,0c1.1,1.1,1.1,3,0,4.1l-10.8,10.8V-7l12.8-12.8 c1.1-1.1,3-1.1,4.1,0c1.1,1.1,1.1,3,0,4.1L105.3,0H117l0.1-0.1c1.1-1.1,3-1.1,4.1,0c0,0,0,0.1,0.1,0.1H132 C131.2-23.6,113-44,104.1-52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M148.9-15.7c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0L165.8-7v-13.8L155-31.7c-1.1-1.1-1.1-3,0-4.1 c1.1-1.1,3-1.1,4.1,0l6.7,6.7v-23.5c-8.8,8.6-27.1,29-27.9,52.6h10.7c0,0,0-0.1,0.1-0.1c1.1-1.1,3-1.1,4.1,0l0.1,0.1h11.7 L148.9-15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M171.6-52.6v7.7c1.9,1.9,6.5,6.6,11,13.1C190-21,194.2-10.1,194.6,0h4.9C198.7-23.6,180.5-44,171.6-52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M171.6-36.4v14.3c0,0,0,0,0,0V0c0,0,0,0,0,0h17.2C188-15.4,177.9-29.2,171.6-36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M64.5,0H36.6c0,0,0,0,0,0v-22.1c0,0,0,0,0,0v-30.5C45.5-44,63.7-23.6,64.5,0z M46.4-3.6 c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4C44.8-0.1,46.4-1.7,46.4-3.6z M46.4-13.6 c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4C44.8-10.2,46.4-11.8,46.4-13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BB68B",
    d: "M13.9-15.7c-1.1-1.1-1.1-3,0-4.1c1.1-1.1,3-1.1,4.1,0L30.8-7v-13.8L20-31.7c-1.1-1.1-1.1-3,0-4.1 c1.1-1.1,3-1.1,4.1,0l6.7,6.7v-23.5C22-44,3.8-23.6,2.9,0h10.7c0,0,0-0.1,0.1-0.1c1.1-1.1,3-1.1,4.1,0L17.9,0h11.7L13.9-15.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#221F1F",
    cx: 42.9,
    cy: -116.9,
    r: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F1F",
    d: "M9.2-71.9c1.9,0,3.4-1.5,3.4-3.4s-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4S7.3-71.9,9.2-71.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#221F1F",
    cx: 9.2,
    cy: -65.3,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#221F1F",
    cx: 9.2,
    cy: -55.2,
    r: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F1F",
    d: "M201.1-123.4H201h-1.5h-0.1c0,0.4,0,0.8,0,1.2c-1.1,0.9-2.8,2.5-5,4.7c0.1-1.3,0.2-2.6,0.2-3.9 c0-0.7,0-1.3,0-2h-5.8c0,0.7,0.1,1.3,0.1,2c0,4.1-0.7,8.1-1.8,12c-1.2,1.5-2.5,3-3.8,4.7c-4.9,6.4-8.8,12.9-11.7,19.3v-18 c0,0,0,0,0,0v-19.9c0,0,0,0,0,0h-7l1.2,1.2v11.7l-12.9-12.9h-4.3c-1.1,1.1-1,2.9,0.1,4l17.1,17.1v16.7 c-8.5-19-23.7-32.9-27.9-36.5c0-0.4,0-0.8,0-1.2h-1.5h-2.8h-1.5H132c0,0.4,0,0.8,0,1.2c-2.6,2.2-9.4,8.4-16.3,17.4 c-4.9,6.4-8.8,12.9-11.7,19.3v-16.8l17.1-17.1c1.1-1.1,1.1-2.9,0.1-4H117l-12.9,12.9v-11.7l1.2-1.2h-7h-1.2l1.2,1.2v11.7 l-12.9-12.9h-4.3c-1.1,1.1-1,2.9,0.1,4l17.1,17.1v16.7c-8.5-19-23.7-32.9-27.9-36.5c0-0.4,0-0.8,0-1.2h-0.1h-1.5h-0.1h-2.6h-0.1 h-1.5c0,0.4,0,0.8,0,1.2c-2.6,2.2-9.4,8.4-16.3,17.4c-4.9,6.4-8.8,12.9-11.7,19.3v-18c0,0,0,0,0,0v-19.9c0,0,0,0,0,0h-7l1.2,1.2 v11.7l-12.9-12.9h-4.3c-1.1,1.1-1,2.9,0.1,4l17.1,17.1v16.7c-8.5-19-23.7-32.9-27.9-36.5c0-0.4,0-0.8,0-1.2H1.4H1.3H0v2.6v32.9v7 v15v7v12.9v7v22.7v2.5v12.5v0.8V0h1.3h0.1h1.5c0.8-23.6,19-44,27.9-52.6v23.5l-6.7-6.7c-1.1-1.1-3-1.1-4.1,0 c-1.1,1.1-1.1,3,0,4.1l10.8,10.8V-7L18-19.8c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1L29.6,0h7c0,0,0,0,0,0v-22.1c0,0,0,0,0,0 v-30.5C45.5-44,63.7-23.6,64.5,0h1.5h0.1h2.6h0.1h1.5h0.1c0.8-23.6,19-44,27.9-52.6v23.5l-6.7-6.7c-1.1-1.1-3-1.1-4.1,0 c-1.1,1.1-1.1,3,0,4.1l10.8,10.8V-7L85.5-19.8c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1L97.1,0h1.2h7L121-15.7 c1.1-1.1,1.1-3,0-4.1c-1.1-1.1-3-1.1-4.1,0L104.1-7v-13.8l10.8-10.8c1.1-1.1,1.1-3,0-4.1c-1.1-1.1-3-1.1-4.1,0l-6.7,6.7v-23.5 C113-44,131.2-23.6,132,0h0.1h1.5h2.8h1.5c0.8-23.6,19-44,27.9-52.6v23.5l-6.7-6.7c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1 l10.8,10.8V-7L153-19.8c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1L164.6,0h7c0,0,0,0,0,0v-22.1c0,0,0,0,0,0v-14.3 c6.2,7.1,16.4,21,17.2,36.4h5.8c-0.5-10.1-4.6-21-12-31.7c-4.6-6.6-9.1-11.3-11-13.1v-7.7c8.8,8.6,27.1,29,27.9,52.6h0.1h1.5h0.1 h1.3v-0.3v-0.8v-15.1v-22.6v-7v-12.9v-7v-15.1v-7v-35.6H201.1z M14.6-43.1C9.7-36.7,5.8-30.2,2.9-23.8v-18c0,0,0,0,0,0v-19.9 c0,0,0,0,0,0v-22.1c0,0,0,0,0,0v-30.5c9,8.7,27.7,29.7,27.9,53.8C28.2-58.2,21.4-52,14.6-43.1z M36.7-60.5 c0.2-24.1,18.9-45.1,27.9-53.8v23.5l-6.7-6.7c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l10.8,10.8v13.8L51.8-81.5 c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l16.9,16.9v11.7l-13-13c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l17.1,17.1v16.7 C56.1-42.9,40.9-56.8,36.7-60.5z M82-43.1c-4.9,6.4-8.8,12.9-11.7,19.3v-16.8l17.1-17.1c1.1-1.1,1.1-3,0-4.1 c-1.1-1.1-3-1.1-4.1,0l-13,13v-11.7l16.9-16.9c1.1-1.1,1.1-3,0-4.1c-1.1-1.1-3-1.1-4.1,0L70.4-68.7v-13.8l10.8-10.8 c1.1-1.1,1.1-3,0-4.1c-1.1-1.1-3-1.1-4.1,0l-6.7,6.7v-23.5c9,8.7,27.7,29.7,27.9,53.8C95.7-58.2,88.9-52,82-43.1z M104.1-60.5 c0.2-24.1,18.9-45.1,27.9-53.8v23.5l-6.7-6.7c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l10.8,10.8v13.8l-12.8-12.8 c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l16.9,16.9v11.7l-13-13c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l17.1,17.1v16.7 C123.6-42.9,108.4-56.8,104.1-60.5z M149.5-43.1c-4.9,6.4-8.8,12.9-11.7,19.3v-18c0,0,0,0,0,0v-19.9c0,0,0,0,0,0v-22.1 c0,0,0,0,0,0v-14.3c6.5,7.5,17.3,22.2,17.3,38.3c0,4.1-0.7,8.1-1.8,12C152-46.3,150.8-44.7,149.5-43.1z M160.8-55.8 c0.1-1.3,0.2-2.6,0.2-3.9c0-10.7-4.2-22.3-12.1-33.7c-4.6-6.6-9.1-11.3-11-13.1v-7.7c9,8.7,27.7,29.7,27.9,53.8 C164.7-59.5,163-58,160.8-55.8z M188.7-93.4l10.8,10.8v13.8l-12.8-12.8c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l16.9,16.9 v11.7l-13-13c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1l17.1,17.1v16.7c-8.5-19-23.7-32.9-27.9-36.5 c0.2-24.1,18.9-45.1,27.9-53.8v23.5l-6.7-6.7c-1.1-1.1-3-1.1-4.1,0C187.6-96.4,187.6-94.5,188.7-93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F1F",
    d: "M81.2-0.1C81.2-0.1,81.2,0,81.2-0.1L85.4,0l-0.1-0.1C84.2-1.2,82.3-1.2,81.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F1F",
    d: "M117.1-0.1L117.1-0.1l4.2,0.1c0,0,0-0.1-0.1-0.1C120.1-1.2,118.3-1.2,117.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F1F",
    d: "M148.7-0.1C148.7-0.1,148.6,0,148.7-0.1l4.2,0.1l-0.1-0.1C151.7-1.2,149.8-1.2,148.7-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F1F",
    d: "M13.7-0.1C13.7-0.1,13.7,0,13.7-0.1L17.9,0l-0.1-0.1C16.7-1.2,14.9-1.2,13.7-0.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#221F1F",
    cx: 42.9,
    cy: -13.6,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#221F1F",
    cx: 42.9,
    cy: -3.6,
    r: 3.4
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M42.9,28.3L49.5,0H29.4L18.1,48.3h14.2l-2,8.4H16.1l-4.7,19.9h34.3L57,28.3H42.9z M43.4,73.7H15.1 l3.3-14.2h14.2l3.3-14.2H21.7l9.9-42.5h14.2l-6.6,28.3h14.2L43.4,73.7z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "53.4,31.2 43.4,73.7 15.1,73.7 18.4,59.6 32.6,59.6 35.9,45.4 21.7,45.4 31.7,2.9  45.9,2.9 39.2,31.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M59.7,28.3l-4.7,19.9h14.2l-2,8.4H53.1l-4.7,19.9h34.3L94,28.3H59.7z M80.4,73.7H52.1l3.3-14.2h14.2 l3.3-14.2H58.7L62,31.2h28.3L80.4,73.7z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000019645481318794603490000001860132845134044295_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000019645481318794603490000001860132845134044295_)",
    points: "90.4,31.2 80.4,73.7 52.1,73.7  55.4,59.6 69.6,59.6 72.9,45.4 58.7,45.4 62,31.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107.6,28.4L101,56.7H90.1l-4.7,19.9h30.9l6.6-28.3h10.9l4.7-19.9H107.6z M131.6,45.4h-10.9l-6.6,28.3h-25 l3.3-14.2h10.9l6.6-28.3h25L131.6,45.4z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000064316919224841757260000005446024630045873573_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000064316919224841757260000005446024630045873573_)",
    points: "134.9,31.2 131.6,45.4 120.7,45.4  114.1,73.7 89.1,73.7 92.4,59.6 103.2,59.6 109.9,31.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M227.9,56.7l6.6-28.3H201l-4.7,19.9h13.4l-2,8.4h-13.4l-4.7,19.9H234l4.7-19.9H227.9z M231.8,73.7h-38.4 l3.3-14.2h13.4l3.3-14.2H200l3.3-14.2h27.5l-6.6,28.3h10.9L231.8,73.7z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000119822323786322522130000005158826452544873088_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000119822323786322522130000005158826452544873088_)",
    points: "235.1,59.6 231.8,73.7 193.4,73.7  196.7,59.6 210.1,59.6 213.4,45.4 200,45.4 203.3,31.2 230.9,31.2 224.2,59.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M170.8,48.3l4.7-19.9h-34.3L130,76.6h34.3l4.7-19.9h-14.2l2-8.4H170.8z M165.2,59.6l-3.3,14.2h-28.3 l9.9-42.5h28.3l-3.3,14.2h-14.2l-3.3,14.2H165.2z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000133490650669718434180000008196536313681529772_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000133490650669718434180000008196536313681529772_)",
    points: "154.4,45.4 151.1,59.6 165.2,59.6  161.9,73.7 133.6,73.7 143.5,31.2 171.9,31.2 168.6,45.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M178.2,28.3l-11.3,48.3H187l11.3-48.3H178.2z M184.7,73.7h-14.2l9.9-42.5h14.2L184.7,73.7z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000065767912462605460980000016450952145182943892_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000065767912462605460980000016450952145182943892_)",
    points: "194.7,31.2 184.7,73.7 170.6,73.7  180.5,31.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M48.3,80.1l-4.7,19.9h14.2l-2,8.4H41.6L37,128.4h34.3l11.3-48.3H48.3z M68.9,125.5H40.6l3.3-14.2h14.2 l3.3-14.2H47.2L50.5,83h28.3L68.9,125.5z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000046315436776358259670000002613473357151505841_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000046315436776358259670000002613473357151505841_)",
    points: "78.9,83 68.9,125.5 40.6,125.5  43.9,111.4 58.1,111.4 61.4,97.2 47.2,97.2 50.5,83  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M11.3,80.1L0,128.4h20.1l6.6-28.3h14.2l4.7-19.9H11.3z M38.6,97.2H24.4l-6.6,28.3H3.6L13.6,83h28.3 L38.6,97.2z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000018930891433225712140000006015530129445024185_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000018930891433225712140000006015530129445024185_)",
    points: "41.9,83 38.6,97.2 24.4,97.2  17.8,125.5 3.6,125.5 13.6,83  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M96.1,80.1l-6.6,28.3H78.6l-4.7,19.9h31l6.6-28.3h10.9l4.7-19.9H96.1z M120.1,97.2h-10.9l-6.6,28.3h-25 l3.3-14.2h10.9L98.4,83h25L120.1,97.2z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000056423812146383548860000008413432380425251465_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000056423812146383548860000008413432380425251465_)",
    points: "123.4,83 120.1,97.2 109.2,97.2  102.6,125.5 77.5,125.5 80.9,111.4 91.7,111.4 98.4,83  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M145.2,107.1h12.2l6.7-27h-34.3l-11.3,48.3h34.3l4.7-19.9h-12.5L145.2,107.1z M153.8,111.4l-3.3,14.2 h-28.3l9.9-42.5h28.3l-5.3,21.3h-12.2l-1.7,7.1H153.8z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000040561127292025211580000002348981427456959372_",
    xlinkHref: "#New_Pattern_5",
    patternTransform: "matrix(0.4118 0 0 0.4118 -3549.843 -3544.7783)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000040561127292025211580000002348981427456959372_)",
    points: "142.9,104.3 141.3,111.4 153.8,111.4  150.5,125.5 122.1,125.5 132.1,83 160.4,83 155.1,104.3  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosciarose04);
export default __webpack_public_path__ + "static/media/bosciarose-04.f55aa72b3085a580326087cf83a191fd.svg";
export { ForwardRef as ReactComponent };